// ヘッダーメニューのカレント表示
function indicateCurrentMenuItem() {
  // 現在のURLパスから親階層の名前を取得
  const pathParts = window.location.pathname.split('/').filter((part) => part.length > 0);
  const parentSlug = pathParts[0];

  // 相続実績の場合は強制的に該当メニューのみ強調し、他は外す
  // アーカイブページ: /magazine_cate/inheritance-cases/
  // 詳細ページ: is-inheritance-caseクラスの存在で判定
  const isInheritanceCases = (pathParts[0] === 'magazine_cate' && pathParts[1] === 'inheritance-cases') ||
                            document.querySelector('.single.is-inheritance-case') !== null;
  
  if (isInheritanceCases) {
    // 既に付与されている強調クラスを除去
    document.querySelectorAll('[data-parent-slug] a.is-paged').forEach((a) => a.classList.remove('is-paged'));

    // data-parent-slug で指定されている場合を最優先で探す
    let target = document.querySelector('[data-parent-slug*="inheritance-cases"]');
    // 見つからなければリンク先で判定
    if (!target) {
      const link = document.querySelector('a[href*="/magazine_cate/inheritance-cases/"]');
      if (link) target = link.closest('[data-parent-slug]') || link;
    }
    if (target) {
      const anchor = target.matches('a') ? target : target.querySelector('a');
      if (anchor) anchor.classList.add('is-paged');
    }
    return; // ここで終了（他のメニューは強調しない）
  }

  // data-parent-slug 属性を持つメニュー項目をループしてマッチするものを探す
  const menuItems = document.querySelectorAll('[data-parent-slug]');
  menuItems.forEach((item) => {
    const parentSlugs = item
      .getAttribute('data-parent-slug')
      .split(',')
      .map((slug) => slug.trim());
    if (parentSlugs.includes(parentSlug)) {
      // 強調表示のためのクラスを追加
      item.querySelector('a').classList.add('is-paged');
    }
  });
}


// sub-fvの存在を確認してクラスを付与
function checkSubFvAndApplyWhiteClass() {
  subFv = document.querySelector('.js-sub-fv');
  
  if (subFv) {
    // sub-fvが存在する場合、bodyにhas-sub-fvクラスを追加
    document.body.classList.add('has-sub-fv');
  }
}

//-------------------------------------------
// DOMロードイベント
//-------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  indicateCurrentMenuItem();
  checkSubFvAndApplyWhiteClass();
});

